<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Nr. cotação</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-4 col-md-3 col-lg-3">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                             
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>      
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
									<option value="0">Em digitação</option>
									<option value="1">Aguardando</option>
                                    <option value="2">Finalizada</option>
                                    <option value="3">Todas</option>
                                </select>
                            </div>                                                                                                                             
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstcotacoes"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0"      class="badge badge-pill badge-primary bdg-digitacao" style="">Em digitação</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 1" class="badge badge-pill badge-primary bdg-aguardando">Aguardando</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 2" class="badge badge-pill badge-primary bdg-entregue">Finalizada</span>
                                    </template>                                      
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                            <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;"><i class="fa fa-navicon"></i></button>
                                        </div>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstcotacoes.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Nr. Cotação:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                                                         
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
                        </div>    
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvitens">Itens da cotação</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvfornecedores">Fornecedores</a>
                                    </li>																								
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                    </li>                                    
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvitens" class="container-fluid tab-pane active">
                                        <div v-show="parseInt(this.opcrud) < 3" class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-2">
                                                <label for="edidprodutoedicao">*Produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-model="vcoddigedicao" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddigedicao)" v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao)" style="text-transform: uppercase;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-5">
                                                <label for="eddescricaoprodutoedicao">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold;">
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-1">
                                                <label for="edundprodutoedicao">Und:</label>
                                                <input type="text" class="form-control form-control-sm" id="edundprodutoedicao" v-model="vundprodutoedicao" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-2">
                                                <label for="edqtditemedicao">*Quantidade:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtditemedicao" v-model="vqtditemedicao" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                            </div>
											<div class="col-sm-12 col-md-6 col-lg-2" style="padding-top: 22px;">
												<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdadicionaritem()" style="width: 100%;"><i class="fa fa-plus"></i> Adicionar</button>
											</div>                                                                                        
                                        </div>
                                        <div class="row">                                            
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table
                                                        :rows="lstitenscotacao"
                                                        :columns="columnsitens"
                                                        :config="config"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                    
                                                    <template slot="slot_idproduto" slot-scope="item">
                                                        {{ item.row.idproduto }}
                                                    </template>
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                </vue-bootstrap4-table>
                                            </div>
                                            <div class="col-md-9">
                                            </div>
											<div class="col-md-3">
												<button v-show="parseInt(this.opcrud) < 3" type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdimportaritenscoletor()"><i class="fa fa-arrow-circle-o-down"></i> Importar itens do coletor</button>
											</div>                                                                                                                                       
                                        </div>
                                    </div>
                                    <div id="dvfornecedores" class="container-fluid tab-pane">
                                        <div v-show="parseInt(this.opcrud) < 3" class="row">
                                            <div class="col-md-3">
                                                <span class="lblselect2">*Fornecedor:</span>
                                                <select id="cbfornecedoredicao" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                                        style="width:100%;" v-model="vidfornecedoredicao">
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="edobsfornecedoredicao">Observações:</label>
                                                <input type="text" v-model="vobsfornecedoredicao"
                                                    class="form-control form-control-sm" id="edobsfornecedoredicao" maxlength="100">
                                            </div>              
                                            <div class="col-md-2">
                                                <label for="edemailfornecedoredicao">*Email:</label>
                                                <input type="mail" v-model="vemailfornecedoredicao"
                                                    class="form-control form-control-sm" id="edemailfornecedoredicao" maxlength="50">
                                            </div>  
                                            <div class="col-md-2">
                                                <label for="edcontatofornecedoredicao">Contato:</label>
                                                <input type="text" v-model="vcontatofornecedoredicao"
                                                    class="form-control form-control-sm" id="edcontatofornecedoredicao" maxlength="50" v-mask="['(##) ####-####', '(##) #####-####']">
                                            </div>                                                                                                                                  
											<div class="col-md-2" style="padding-top: 22px;">
												<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdadicionarfornecedor()" style="width: 100%;"><i class="fa fa-plus"></i> Adicionar</button>
											</div>                                                                                                         
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table
                                                        :rows="lstfornecedorescotacao"
                                                        :columns="columnsfornecedores"
                                                        :config="config"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>    
                                                    <template slot="slot_idfornecedor" slot-scope="item">
                                                        {{mtdformatarzeros(item.row.idfornecedor, 4)}}
                                                    </template>                                                                                    
                                                    <template slot="slot_fantasia" slot-scope="item">
                                                        {{ item.row.fantasia }}
                                                    </template>
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluirfornecedor(item.row)"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                </vue-bootstrap4-table>
                                            </div>                                                                                       
                                        </div>
                                    </div>
                                    <div id="dvobservacoes" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>											
										</div>                                        
                                    </div>                                                                            
                                </div>                                                                    
                            </div>
                        </div>                                                
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Lista de cotação -->
                <div id="pnlstcotacao" class="card" style="display:none;">
                    <div class="card-header"><span>Cotação de fornecedores</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdfechalistacotacao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edidc">Nr. Cotação:</label>
                                <input type="text" class="form-control form-control-sm" id="edidc" v-model="nrcotacao"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <label for="eddescricaoc">*Descrição:</label>
                                <input type="text" v-model="desccotacao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricaoc" maxlength="50">
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilialcotacao" data-placeholder="Selecione uma filial" v-model="filcotacao" disabled data-allow-clear="true" style="width:100%;">
								</select>
							</div>                                                         
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtemissaoc">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissaoc" v-model="vdtemissaocotacao" :config="options"
										class="form-control form-control-sm" disabled></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
                        </div> 
                        <div class="row mt-4">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvfornecedorescotacao">Fornecedores</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvitenscotacao">Itens da cotação</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcamparativodepr">Comparação de preço</a>
                                    </li>                                   
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvfornecedorescotacao" class="container-fluid tab-pane active">
                                        
                                        <vue-bootstrap4-table
                                                :rows="lstcotacaofornecedores"
                                                :columns="columnscotacaofornecedores"
                                                :config="config"
                                                :classes="classes">
                                            <template slot="empty-results">
                                                <div class="col-md-12 text-center">Sem dados para visualização</div>
                                            </template>
                                            <template slot="slot_idfornecedor" slot-scope="item">
                                                {{mtdformatarzeros(item.row.idfornecedor)}}
                                            </template>                                                                                    
                                            <template slot="slot_nomerazaosocial" slot-scope="item">
                                                {{ item.row.nomerazaosocial}}
                                            </template>                                                                                    
                                            <template slot="slot_frete" slot-scope="item">
                                                {{ mtdformatavalordecimal(parseFloat(item.row.frete), 2)}}
                                            </template>
                                            <template slot="slot_totalipi" slot-scope="item">
                                                {{mtdformatavalordecimal(parseFloat(item.row.totalipi), 2)}}
                                            </template>
                                            <template slot="slot_totalprodutos" slot-scope="item">
                                                {{mtdformatavalordecimal(parseFloat(item.row.totalprodutos), 2)}}
                                            </template>
                                            <template slot="slot_totalst" slot-scope="item">
                                                {{mtdformatavalordecimal(parseFloat(item.row.totalst)), 2}}
                                            </template>
                                            <template slot="slot_totalpedido" slot-scope="item">
                                                {{mtdformatavalordecimal(parseFloat(item.row.totalpedido), 2)}}
                                            </template>
                                            <template slot="slot_observacao" slot-scope="item">
                                               <span class="limitadotext">{{  item.row.observacao? item.row.observacao : "" }}</span> 
                                            </template>
                                            <template slot="slot_visucotacao" slot-scope="item">
                                                <span><i title="Exibir produtos cotação" style="cursor: pointer;" class="fa fa-eye" aria-hidden="true" @click.prevent="mldexibecotacao(item.row.produtoscotacao, item.row.nomerazaosocial, item.row)"></i></span>
                                            </template>
                                        </vue-bootstrap4-table>
                                        <!-- <div class="container-fluid">
                                            <div class="row" v-if="lstcotacaofornecedores">
                                                <div class="col-12">
                                                    <div class="table-responsive">
                                                        <table id="tblistanotasfor" class="table table-bordered table-sm table-hover">
                                                            <thead class="thead-dark">
                                                            <tr>
                                                                <th></th>
                                                                <th>Cod.</th>
                                                                <th>Fornecedor</th>
                                                                <th>Frete</th>
                                                                <th>Total IPI</th>
                                                                <th>Total ST</th>
                                                                <th>Total produtos</th>
                                                                <th>Total pedido</th>
                                                                <th>Observação</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-for="(cotacao, index) in lstcotacaofornecedores">
                                                                    <tr  v-bind:key="index" style="font-size: 12px;" @click.prevent="mtdexpandiritens(index)">
                                                                        <td class="text-center">
                                                                            <span v-if="linhaExpandida == null" style="font-size: 20px; cursor: pointer;" @click.prevent="mtdexpandiritens(index)"><i class="fa fa-chevron-circle-down text-primary"></i></span>
                                                                            <span v-else style="font-size: 20px; cursor: pointer;"><i class="fa fa-chevron-circle-up text-primary" @click.prevent="mtdexpandiritens(index)"></i></span>													
                                                                        </td> 
                                                                        <td>{{ cotacao.idfornecedor }}</td>
                                                                        <td>{{ cotacao.nomerazaosocial }}</td>
                                                                        <td>{{ cotacao.frete }}</td>
                                                                        <td>{{ cotacao.totalipi }}</td>
                                                                        <td>{{ cotacao.totalst }}</td>
                                                                        <td>{{ cotacao.totalprodutos }}</td>
                                                                        <td>{{ cotacao.totalpedido }}</td>
                                                                        <td>{{ cotacao.observacao }}</td>
                                                                    </tr>
                                                                    <tr v-bind:key="'produtos - '+index"  style="font-size: 10px;">
                                                                    <td colspan="9" v-show="linhaExpandida === index" style="padding-left: 35px; padding-right: 35px;">
                                                                            <table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 2px; margin-bottom: 2px;">
                                                                                <thead class="thead-light">
                                                                                    <tr>
                                                                                        <td>Código</td>
                                                                                        <td>Descrição</td>
                                                                                        <td>Und</td>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr  v-for="(item, indexi) in cotacao.produtoscotacao">
                                                                                        <td>{{ item.idproduto }}</td>
                                                                                        <td>{{ item.descricao }}</td>
                                                                                        <td>{{  mtdformatavalordecimal(parseFloat(item.valor), 2) }}</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                    </td>
                                                                    </tr>
                                                                </template>    
                                                            </tbody>                                        
                                                        </table>
                                                    </div>
                                                </div>                                                                               
                                            </div>
                                            <div class="row" v-else>
                                                <div class="col-12" style="display: flex; justify-content: center;">
                                                    <big style="padding: 20px;"><i class="fa fa-search"></i> Nenhum registro encontrado para sua busca.</big>
                                                </div>
                                            </div>
                                        </div>  -->
                                    </div>
                                    <div id="dvitenscotacao" class="container-fluid tab-pane">
                                        <!-- <vue-bootstrap4-table
                                                :rows="lstcotacaoprodutos"
                                                :columns="columnscotacaoprodutos"
                                                :config="config"
                                                :classes="classes">
                                            <template slot="empty-results">
                                                <div class="col-md-12 text-center">Sem dados para visualização</div>
                                            </template> 
                                            <template slot="slot_codigo" slot-scope="item">
                                                {{mtdformatarzeros(item.row.idproduto)}}
                                            </template>                                                                                    
                                            <template slot="slot_descricao" slot-scope="item">
                                                {{mtdformatarzeros(item.row.descricao)}}
                                            </template>                                                                                    
                                            <template slot="slot_referencia" slot-scope="item">
                                                {{mtdformatarzeros(item.row.referencia)}}
                                            </template>
                                            <template slot="slot_qtditem" slot-scope="item">
                                                {{mtdformatarzeros(item.row.qtditem)}}
                                            </template>
                                            <template slot="slot_und" slot-scope="item">
                                                {{mtdformatarzeros(item.row.und)}}
                                            </template>
                                        </vue-bootstrap4-table> -->
                                        <div class="container-fluid">
                                            <div class="row" v-if="lstcotacaoprodutos">
                                                <div class="col-12 p-0 m-0">
                                                    <div class="table-responsive">
                                                        <table id="tblistanotasfor" class="table table-bordered table-sm table-hover" >
                                                            <thead style="color: #cccccc; background-color: #1e2b37;">
                                                            <tr>
                                                                <th></th>
                                                                <th></th>
                                                                <th>Código</th>
                                                                <th>Descrição</th>
                                                                <th>Referência</th>
                                                                <th>Qtd</th>
                                                                <th>Und</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody v-for="(cotacao, index) in lstcotacaoprodutos">
                                                                <tr v-bind:key="index" style="font-size: 12px;" >
                                                                    <td style="width: 30px;">
                                                                        <div class="custom-control custom-checkbox">
                                                                            <input type="checkbox" class="custom-control-input" :id="'idcheck_prod' + index + '_' + cotacao.idproduto" v-model="lstitenspedido" 
                                                                                :value= cotacao >
                                                                            <label class="custom-control-label" :for="'idcheck_prod' + index + '_' + cotacao.idproduto"></label>
                                                                        </div>
                                                                    </td>
                                                                    <td style="width: 60px;" class="text-center">
                                                                        <span v-if="linhaExpandida == null" ><i style="font-size: 20px; cursor: pointer; z-index: 999999" @click.prevent="mtdexpandiritens(index)" class="fa fa-chevron-circle-down text-primary"></i></span>
                                                                        <span v-else ><i style="font-size: 20px; cursor: pointer;" class="fa fa-chevron-circle-up text-primary" @click.prevent="mtdexpandiritens(index)"></i></span>													
                                                                    </td> 
                                                                    <td style="width: 60px;">{{ cotacao.idproduto }}</td>
                                                                    <td>{{ cotacao.descricao }}</td>
                                                                    <td>{{ cotacao.referencia }}</td>
                                                                    <td style="width: 80px; text-align: end;">{{ cotacao.qtditem }}</td>
                                                                    <td>{{ cotacao.und }}</td>
                                                                </tr>
                                                                <tr v-bind:key="'produtos - '+index"  style="font-size: 10px;">
                                                                <td colspan="9" v-show="linhaExpandida === index" >
                                                                    <table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 2px; margin-bottom: 2px;">
                                                                        <thead class="thead-light">
                                                                            <tr>
                                                                                <!-- <td></td> Parei aqui -->
                                                                                <td>Cod.</td>
                                                                                <td>Fornecedor</td>
                                                                                <td>Pr. Unitário</td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item, index) in cotacao.precofornecedor">
                                                                                <td style="width: 60px;">{{ item.idfornecedor }}</td>
                                                                                <td>{{ item.nomerazaosocial }}</td>
                                                                                <td style="text-align: end; width: 90px;" :class="{ 'menorpreco': parseFloat(item.vlunitario) === mtdverificamenorpreco(cotacao.precofornecedor) }">{{  mtdformatavalordecimal(parseFloat(item.vlunitario), 2) }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                                </tr>
                                                            </tbody>                              
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="col-9"></div>
                                                <div class="col-3 p-2">
                                                    <button type="button" @click.prevent="mtdgerarpedidocompraitens()" class="btn btn-secondary btn-sm" style="width:100%;">
                                                        <i class="fa fa-archive"></i> Gerar pedido com produtos selecionados
                                                    </button>
                                                </div>                                                                            
                                            </div>
                                            <div class="row" v-else>
                                                <div class="col-12" style="display: flex; justify-content: center;">
                                                    <big style="padding: 20px;"><i class="fa fa-search"></i> Nenhum registro encontrado para sua busca.</big>
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                    <div id="dvcamparativodepr" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4" v-for="(fornecedor, index) in lstcotacaofornecedores" :key="index">
                                                <div class="card cardcotacao mb-3" style="min-height: 500px;">
                                                   <div class="card-header headercardcotacao" :class="{ 'headermelhorpreco': index === 0 }">
                                                        <h5 class="mb-0">
                                                            <i class="fa fa-truck mr-2" aria-hidden="true"></i>
                                                            {{ fornecedor.nomerazaosocial }}
                                                        </h5>
                                                        <p class="mb-0 text-white-50" v-if="index === 0">
                                                            <i class="fa fa-star" aria-hidden="true"></i>
                                                            Melhor oferta com {{ fornecedor.itens }} item(s) cotados.
                                                        </p>
                                                    </div> 
                                                    <div class="card-body">
                                                        <div class="d-flex justify-content-between align-items-center mb-3">
                                                            <h6 class="text-uppercase text-muted mb-0">Valor Total:</h6>
                                                            <span class="totalpedido">{{ mtdformatavalordecimal(parseFloat(fornecedor.totalprodutos, 2)) }}</span>
                                                        </div>
                                                        <p class="font-weight-bold mb-2">Detalhes dos Itens:
                                                            <br><small>Produtos com o menor preço</small>
                                                        </p>
                                                        <div class="table-responsive">
                                                            <table class="table table-sm table-striped produtoscardcotacao">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Produto</th>
                                                                        <th class="text-right">Preço Unitário</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, itemIndex) in ordenamenorpreco(fornecedor.produtoscotacao)" :key="itemIndex">
                                                                        <td>
                                                                            {{ item.descricao }}  
                                                                            <span style="font-size: 10px;"> Uni {{ item.qtditem }} </span></td>
                                                                        <td class="text-right" :class="{ 'menorpreco': parseFloat(item.vlunitario) == mtdverificamenorpreco(fornecedor.produtoscotacao) }">{{ mtdformatavalordecimal(parseFloat(item.vlunitario ,2)) }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div>
                                                            <button class="btn btn-sm btnexibecard" style="cursor: pointer;" @click.prevent="mdtexibeprodutoscardcotacao(fornecedor.produtoscotacao)" >Visualizar todos <i class="fa fa-caret-down" aria-hidden="true"></i></button>
                                                        </div>
                                                    </div>
                                                    <div class="card-footer bg-white d-flex justify-content-end mb-2">
                                                        <button class="btn btn-outline-secondary btn-sm btnpedidocotacao" @click.prevent="mtdrealizarpedidocompra(fornecedor, '', 1)">
                                                            <i class="fa fa-external-link" aria-hidden="true"></i>
                                                            Realizar pedido
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                        </div>                                                
                    </div>
                    <div class="card-footer">
                        <div class="row" style="display: flex; justify-content: end;">
                            <div class="col-2 p-2">
                                <button type="button" @click.prevent="mtdfechalistacotacao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL DE GERAÇÃO DE LINK -->
        <div class="modal fade" id="mdllinkcotacao" tabindex="-1" role="dialog" aria-labelledby="tituloModal" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content" style="border-radius: 20px;">
                    <div class="modal-header" style="border-top-left-radius: 20px; border-top-right-radius: 20px;">
                        <h5 class="modal-title" id="tituloModal">
                            Links para fornecedores
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12"  style="user-select: none;">
                              <table class="table table-bordered table-sm table-striped modal-tabela m-0">
                                <thead>
                                    <tr style="font-weight: bold;">
                                    <th style="width: 60px; text-align: center;">Cod.</th>
                                    <th style="width: 200px;">Fornecedor:</th>
                                    <th>E-mail:</th>
                                    <th style="width: 90px; text-align: center;">Ações</th>
                                    </tr>
                                </thead>
                                <tbody id="tbprodpromo">
                                    <tr v-for="(fornecedor, index) in lstlinkfornecedores.fornecedores" :key="index">
                                    <td style="text-align: center;">{{ fornecedor.idfornecedor }}</td>
                                    <td style="text-align: center;">{{ fornecedor.fantasia }}</td>
                                    <td style="text-align: left;  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px; ":title="lstlinkfornecedores.linkcotacao">
                                        {{ fornecedor.email }}
                                    </td>
                                    <td style="text-align: center;">
                                        <div style="display: flex; gap: 4px; justify-content: center;">
                                            <button
                                                @click.prevent="mtdcopialinkcotacao(fornecedor.link)" class="btn btn-secondary btn-sm" title="Copiar link">
                                                <i class="fa fa-clone" aria-hidden="true"></i>
                                            </button>
                                            <button class="btn btn-secondary btn-sm" title="Enviar cotação" @click.prevent="mtdenviaemailcotacao( 0, fornecedor, fornecedor.link)">
                                                <i class="fa fa-paper-plane-o" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" @click.prevent="mtdenviaemailcotacao(1, lstlinkfornecedores.fornecedores, lstlinkfornecedores.fornecedores.link)">
                            <i class="fa fa-send"></i> Enviar para todos
                        </button>
                        <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">
                            <i class="fa fa-close"></i> Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL DETALHES COTACAO  -->
        <div class="modal fade" id="mdldetalhescotacao" tabindex="-1" role="dialog" aria-labelledby="tituloModal" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content" style="border-radius: 15px;">
                    <div class="modal-header" style="border-top-right-radius: 15px; border-top-left-radius: 15px;">
                        <h5 class="modal-title" id="tituloModal">
                            COTAÇÃO - {{ titulocotacaofor }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="idc">Cod.</label>
                                <input type="text" class="form-control form-control-sm" id="idc" v-model="itemcotacao.idfornecedor"
                                        maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="edidf">Fornecedor:</label>
                                <input type="text" class="form-control form-control-sm" id="edidf" v-model="itemcotacao.nomerazaosocial"
                                        maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbqtdreg">Tipo frete:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="itemcotacao.tpfrete" disabled>
                                    <option value="0">Por conta do emitente (CIF)</option>
                                    <option value="1">Por conta do destinatário/remetente (FOB)</option>
                                    <option value="2">Sem frete / Retirada no local</option>
                                    <option value="3">Frete terceirizado</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edidob">Observação:</label>
                                <textarea class="form-control center" type="text"  id="edidob" v-model="itemcotacao.observacao" maxlength="20" disabled/>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12">
                                <div class="col-12"  style="user-select: none;">
                                  <table class="table table-bordered table-sm table-striped modal-tabela m-0">
                                    <thead>
                                        <tr>
                                            <th style="text-align: left;">PRODUTO</th>
                                            <th style="text-align: left;">REFERÊNCIA</th>
                                            <th style="text-align: left;">QTD.</th>
                                            <th style="text-align: left;">UNID.</th>
                                            <th style="text-align: left;">VALOR.</th>
                                        </tr>
                                    </thead>
                                    <tbody id="tbprodpromo">
                                        <tr v-for="(produtos, index) in produtoscotacaofor" :key="index">
                                        <td style="text-align: left;">{{produtos.descricao}}</td>
                                        <td>{{produtos.referencia}}</td>
                                        <td>{{produtos.qtditem}}</td>
                                        <td>{{produtos.und}}</td>
                                        <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(produtos.vlunitario), 2)}}</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                    <div class="col-12 mt-2 p-0 m-0">
                                        <a class="list-group-item">Total da produtos<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(parseFloat(itemcotacao.totalprodutos)) }}</span></a>
                                        <a class="list-group-item">Total ST<span class="badge badge-info bdg-totais" >{{ mtdformatavalordecimal(parseFloat(itemcotacao.totalst)) }}</span></a>
                                        <a class="list-group-item">Total IPI<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(parseFloat(itemcotacao.totalipi)) }}</span></a>
                                        <a class="list-group-item">Total frete<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(parseFloat(itemcotacao.frete)) }}</span></a>
                                        <a class="list-group-item" style="font-weight: bold;">Total da pedido<span class="badge badge-info bdg-totais" style="background-color: #5A956A;">{{ mtdformatavalordecimal(parseFloat(itemcotacao.totalpedido)) }}</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
                        <i class="fa fa-close"></i> Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL PEDIDO POR PRODUTOS -->
        <div class="modal fade" id="mdlpedidoitem" tabindex="-1" role="dialog" aria-labelledby="tituloModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content" style="border-radius: 15px;">
                    <div class="modal-header" style="border-top-right-radius: 15px; border-top-left-radius: 15px;">
                        <h5 class="modal-title" id="tituloModal">
                            Pedido de compra por item
                        </h5>
                        <button type="button" class="close" @click.prevent="mtdfechamodalpedidoitens()" aria-label="Fechar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                            <label for="cbforn">Fornecedor:</label>
                            <select class="form-control form-control-sm" v-model="fornecedorpedidoitem" id="cbforn">
                                <option value="" disabled>--  Selecione um fornecedor --</option>
                                <option 
                                v-for="fornecedor in lstcotacaofornecedores" 
                                :key="fornecedor.idfornecedor"
                                :value="fornecedor.idfornecedor"
                                >
                                {{ fornecedor.nomerazaosocial }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12">
                                <div class="col-12"  style="user-select: none;">
                                  <table class="table table-bordered table-sm table-striped modal-tabela m-0">
                                    <thead>
                                        <tr>
                                            <th style="text-align: left;">PRODUTO</th>
                                            <th style="text-align: left;">REFERÊNCIA</th>
                                            <th style="text-align: left;">QTD.</th>
                                            <th style="text-align: left;">UNID.</th>
                                            <th style="text-align: left;">Pr. Unitário</th>
                                            <th style="text-align: left;">Total produto</th>
                                        </tr>
                                    </thead>
                                        <tbody id="tbprodpromo">
                                            <tr v-for="(produtos, index) in lstitensselecionadospedido" :key="index">
                                                <td style="text-align: left;">{{produtos.descricao}}</td>
                                                <td>{{produtos.referencia}}</td>
                                                <td>{{produtos.qtditem}}</td>
                                                <td>{{produtos.und}}</td>
                                                <td style="text-align: right;">
                                                    {{mtdformatavalordecimal(mtdatualizaprecofornecedor(produtos.precofornecedor, fornecedorpedidoitem), 2)}}
                                                </td>
                                                <td style="text-align: right;">
                                                    {{mtdformatavalordecimal(mtdatualizaprecofornecedor(produtos.precofornecedor, fornecedorpedidoitem) * produtos.qtditem, 2)}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm"  @click.prevent="mtdrealizarpedidocompra(lstitensselecionadospedido, fornecedorpedidoitem, 2)">
                        <i class="fa fa-external-link" ></i> Gerar pedido
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm" @click.prevent="mtdfechamodalpedidoitens()">
                        <i class="fa fa-close"></i> Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL lista de produtos -->
        <div class="modal fade" id="mdlexibeprodutoscard" tabindex="-1" role="dialog" aria-labelledby="tituloModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content" style="border-radius: 15px;">
                    <div class="modal-header" style="border-top-right-radius: 15px; border-top-left-radius: 15px;">
                        <h5 class="modal-title" id="tituloModal">
                            Pedido de compra por item
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="col-12"  style="user-select: none;">
                                  <table class="table table-bordered table-sm table-striped modal-tabela m-0">
                                    <thead>
                                        <tr>
                                            <th style="text-align: left;">PRODUTO</th>
                                            <th style="text-align: left;">REFERÊNCIA</th>
                                            <th style="text-align: left;">QTD.</th>
                                            <th style="text-align: left;">UNID.</th>
                                            <th style="text-align: left;">Pr. Unitário</th>
                                            <th style="text-align: left;">Total produto</th>
                                        </tr>
                                    </thead>
                                        <tbody id="tbprodpromo">
                                            <tr v-for="(produtos, index) in exibeprodutoscard" :key="index">
                                                <td style="text-align: left;">{{produtos.descricao}}</td>
                                                <td>{{produtos.referencia}}</td>
                                                <td>{{produtos.qtditem}}</td>
                                                <td>{{produtos.und}}</td>
                                                <td style="text-align: right;">
                                                    {{ mtdformatavalordecimal( parseFloat(produtos.vlunitario) , 2) }}
                                                </td>
                                                <td style="text-align: right;">
                                                    {{mtdformatavalordecimal(parseFloat(produtos.vlunitario * produtos.qtditem), 2)}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"">
                        <i class="fa fa-close"></i> Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL MENU -->
        <div class="modal fade" id="mdlmenu">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="list-group" style="cursor: pointer;">
                                    <li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ (rowcotacao.id) }}</li>
                                    <button type="button" class="list-group-item list-group-item-action font-weight-bold"  style="color: #6c757d;" @click.prevent="mtdgeralinkcotacaofornecedoratz(rowcotacao)"><i class="fa fa-link"></i> GERAR LINK COTAÇÃO</button>
                                    <button type="button" class="list-group-item list-group-item-action font-weight-bold"  style="color: #6c757d;" @click.prevent="mtdlistacotacoes(rowcotacao)"><i class="fa fa-line-chart "></i> VISUALIZAR COTAÇÕES</button>
                                    <button type="button" class="list-group-item list-group-item-action font-weight-bold"  style="color: #6c757d;" @click.prevent="mtdfinalizacotacao(rowcotacao)"><i class="fa fa-ban"></i> ENCERRAR PEDIDO COTAÇÃO</button>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" style="padding: 5px;">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
                                </div>
                            </div>					
                        </div>
                    </div>				        
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadcotacoes',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos
        },
        data: function() {
            return {
                utodasfiliais           : this.$store.state.usuario.todasfiliais,
                //variaveis da consulta de produtos
				vshowprtabela			: false,//oculta a visualização do preço do produto na listagem
				vidtabela				: 1,//informo somente pq o componente exige
                tipopropesquisa         : '',

                lstcotacoes  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pidfilial    : null,
				pfiltroperiodo      : 1,
				pdtini       		: util.DataAtual(true),
                pdtfim       		: util.DataAtual(true),
                psituacao           : 3,                
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                // LINK DE COTAÇÂO:
                linkcotacaocriptografado       : '',

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                vidfilial           : null,
                vdtemissao			: util.DataAtual(),
                vobservacoes            : '',
                lstitenscotacao         : [],
                lstfornecedorescotacao  : [],
                lstlinkfornecedores     : [],

                nrcotacao              : '',
                desccotacao            : '',
                filcotacao             : null,
                vdtemissaocotacao      : null,


                //variaveis de edicao do item
                vitem                       : 0,
				vidprodutoedicao    		: '',
				vcoddigedicao				: '',
				vdescricaoprodutoedicao 	: '',
				vundprodutoedicao			: '',
				vqtditemedicao				: 1,
				vfracionadoedicao			: 0,
				vreferenciaedicao  		    : '',
                
                //variaveis de edição fornecedores
                vidfornecedoredicao         : null,
                vobsfornecedoredicao        : '',
                vemailfornecedoredicao      : '',
                vcontatofornecedoredicao    : '',

                // variavei da vizualização cotação
                lstcotacaofornecedores    : [],
                linhaExpandida            : null,
                produtoscotacaofor        : [],
                titulocotacaofor          : '',
                itemcotacao               : [],
                fantasiafil               : '',
                descfor                   : '',
                lstitenspedido            : [],
                fornecedorpedidoitem      : '',
                lstitensselecionadospedido : [],
                rowcotacao                 : [],
                exibeprodutoscard          : [],

                


                //variável para habilitação dos campos
                ativadesativa       : true,

                lstcotacaoprodutos  : [],

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'COTAÇÕES',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Nr. Cotação",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Filial",
                        name: "fantasiafilial",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        sort: true,
                        slot_name: "slot_dtemissao",
                        row_classes: "def-col-dtemissao",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    }
                ],                
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                },
                columnsitens: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        sort: true,
                        slot_name: "slot_item",
                        row_classes: "def-col-item",
                        row_text_alignment: "text-right",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "slot_idproduto",
                        row_classes: "def-col-idproduto",
                        row_text_alignment: "text-right",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Und",
                        name: "und",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                columnsfornecedores: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "idfornecedor",
                        sort: true,
                        slot_name: "slot_idfornecedor",
                        row_classes: "def-col-idfornecedor",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Fornecedor",
                        name: "fantasia",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_fantasia",
                        row_classes: "def-col-fantasia",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Email",
                        name: "email",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Contato",
                        name: "contato",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Observações",
                        name: "observacoes",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                columnscotacaoprodutos: [
                    {
                        label: "Código",
                        name: "codigo",
                        sort: true,
                        slot_name: "slot_codigo",
                        row_classes: "def-col-idcodigo",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_descricao",
                        row_classes: "def-col-descricao",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_referencia",
                        row_classes: "def-col-referencia",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_qtditem",
                        row_classes: "def-col-qtditem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Und",
                        name: "und",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_und",
                        row_classes: "def-col-und",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },
                ],
                columnscotacaofornecedores: [
                    {
                        label: "Cod.",
                        name: "idfornecedor",
                        sort: true,
                        slot_name: "slot_idfornecedor",
                        row_classes: "def-col-idfornecedor",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Fornecedor",
                        name: "nomerazaosocial",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_nomerazaosocial",
                        row_classes: "def-col-nomerazaosocial",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Frete",
                        name: "frete",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_frete",
                        row_classes: "def-col-frete",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Total IPI",
                        name: "totalipi",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_totalipi",
                        row_classes: "def-col-totalipi",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Total produtos",
                        name: "totalprodutos",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_totalprodutos",
                        row_classes: "def-col-totalprodutos",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Total ST",
                        name: "totalst",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_totalst",
                        row_classes: "def-col-totalst",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Total pedido",
                        name: "totalpedido",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_totalpedido",
                        row_classes: "def-col-totalpedido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Observação",
                        name: "observacao",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_observacao",
                        row_classes: "def-col-observação",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "",
                        name: "detalhes",
                        sort: true,
                        initial_sort : true,
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_visucotacao",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },

                ],
            }
        },
        methods:{
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},            
            mtddefiniciais(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                

				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
                    vself.fantasiafil =  $("#cbfilial").select2('data')[0];
                    //vself.fantasiafil = dadosfil.text
				});                

                $("#cbfornecedoredicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfornecedoredicao = $("#cbfornecedoredicao").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and f.id='+vself.vidfornecedoredicao;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.vemailfornecedoredicao   = response.data[0].email;
                        vself.vcontatofornecedoredicao = response.data[0].fone1;
                    }).catch(function (response) {
                        loader.hide();
                    });                    
                });                
            },
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},            
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and c.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(c.descricao) like upper("'+this.pconteudo+'%")';
                }
                if (this.pidfilial !== null){
                    rfiltro = rfiltro +' and c.idfilial='+this.pidfilial;
                }                 
				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and c.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
				}
                if(this.psituacao != 3){
                    rfiltro = 'and c.situacao = ' + this.psituacao;
                }                
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcotacoes.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregacotacoes(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregacotacoes(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcotacoes.php');
                retorno.then(function (response) {
                    vself.lstcotacoes = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstcotacoes = [];

                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.vitem                  = 0;
                this.vid                    = '';
                this.vdescricao             = '';
                this.vdtemissao			    = util.DataAtual();
                this.vobservacoes           = '';
                this.lstitenscotacao        = [];
                this.lstfornecedorescotacao = [];

                this.vidfilial              = null;

                $("#cbfilial").val(null).trigger('change');
                $("#cbfornecedoredicao").val(null).trigger('change');

                this.mtdlimparedicaoitem();

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdlistacotacoes(item){
                var vself       = this;
                
                let loader      = this.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac',   valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',             valor : 'listagemcotacaofornecedores'},
                    {parametro: 'fornecedores',   valor : JSON.stringify(item.fornecedores)},
                    {parametro: 'lstprodutos',   valor : JSON.stringify(item.itens)},
                    {parametro: 'idcotacao',      valor : item.id},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcotacoes.php');
                retorno.then(function (response) {
                    if (response.data.produtos && response.data.fornecedores) {
                        vself.mtdlocalizaregistro(item.id);
                        vself.lstcotacaoprodutos = response.data.produtos;
                        vself.lstcotacaofornecedores = response.data.fornecedores;
                        
                        $('#mdlmenu').modal('hide');
                        $('#pnlista').hide();
                        $('#pnlstcotacao').fadeIn(700);
    
                        vself.$nextTick(function () {
                            if (parseInt(vself.opcrud) < 3) {
                                $('#eddescricao').focus();
                            } else {
                                $('#btgravar').focus();
                            }
                        });
                        $('.nav-tabs a[href="#dvfornecedorescotacao"]').tab('show');
                     } else {
                         vself.$toastr.i(' Verifique o status da cotação e reenvie, se necessário.', 'Nenhuma proposta recebida para esta cotação.');
                     }
                    loader.hide();
                }).catch(function (response) {
                    vself.lstcotacoes = [];
                    loader.hide();
                });
            },
            mtdfinalizacotacao(item){
                 var vself       = this;
                 if(item.situacao != 2){
                     $.confirm({
                        title: 'Confirmação!',
                        content: 'Dejesa finalizar cotação ?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader      = vself.$loading.show();
    
                                    let parametros  = [
                                        {parametro: 'idclientesac',   valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',             valor : 'finalizacotacao'},
                                        {parametro: 'idcotacao',      valor : item.id},
                                        {parametro: 'idfilial',       valor : item.idfilial},
                                        
                                    ];
                                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcotacoes.php');
                                    retorno.then(function (response) {
                                        if ($.isNumeric(response.data)){
                                            $('#mdlmenu').modal('hide');
                                            vself.$toastr.s('Cotação finalizada com sucesso!', 'Informação!');
                                            vself.mtdcarregacotacoes(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                        loader.hide();
                                    }).catch(function (response) {
                                        vself.lstcotacoes = [];
                                        loader.hide();
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $('#btgravar').focus();
                                }
                            }
                        }
                    });
                 }else{
                    this.$toastr.w('Cotação já está encerrada.', 'Informação!');
                    return;
                 }
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvitens"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('010Z.003Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE COTAÇÃO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdfechalistacotacao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pnlstcotacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstcotacoes = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and c.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcotacoes.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('010Z.003Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if(item.situacao != 2){
                        this.itensbc.item2.titulo = 'ALTERAÇÃO DE COTAÇÃO';
                        this.itensbc.item1.ativo = true;
                        this.itensbc.item2.ativo = true;
                        this.ativadesativa = false;
                        this.mtdpreparacrud(2);
                        this.mtdlocalizaregistro(item.id);
                    }else{
                        this.$toastr.w('Não é possivel alterar uma cotação finalizada!', 'Informação!');
                        return;
                    }
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('010Z.003Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE COTAÇÃO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                    = registro.id;
                this.vidfilial              = registro.idfilial;
                this.vdescricao             = registro.descricao;
                this.vdtemissao			    = registro.dtemissao;
                this.vobservacoes           = registro.observacoes;
                this.lstitenscotacao        = registro.itens;
                this.lstfornecedorescotacao = registro.fornecedores;

                this.nrcotacao              = registro.id;
                this.desccotacao            = registro.descricao;
                this.filcotacao             = registro.idfilial;
                this.vdtemissaocotacao      = registro.dtemissao;
                this.vitem  = this.lstitenscotacao[this.lstitenscotacao.length - 1].item;

                var deffilial  = new Option(registro.fantasiafilial, registro.idfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');                
                
                var deffilialcotacao  = new Option(registro.fantasiafilial, registro.idfilial, true, true);
				$('#cbfilialcotacao').append(deffilialcotacao).trigger('change');                
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'idfilial'          : this.vidfilial,
                    'descricao'         : this.vdescricao,
                    'dtemissao'			: this.mtdformatadatagravar(this.vdtemissao),
                    'observacoes'       : this.vobservacoes,
                    'itens'             : this.lstitenscotacao,
                    'fornecedores'      : this.lstfornecedorescotacao
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '010Z.003Z.010Z' : parseInt(this.opcrud) === 2 ? '010Z.003Z.020Z' : '010Z.003Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcotacoes.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregacotacoes(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },			
			mtdlimparedicaoitem(){
				this.vidprodutoedicao    		= '';
				this.vcoddigedicao				= '';
				this.vdescricaoprodutoedicao 	= '';
				this.vundprodutoedicao			= '';
				this.vqtditemedicao				= 1;
				this.vfracionadoedicao			= 0;
				this.vreferenciaedicao  		= '';				   
			},
            mtdlimparedicaofornecedor(){
                this.vidfornecedoredicao        = null;
                this.vobsfornecedoredicao       = '';
                this.vemailfornecedoredicao     = '';
                this.vcontatofornecedoredicao   = '';
                $("#cbfornecedoredicao").val(null).trigger('change');
            },            					
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vidprodutoedicao			= produto.id;
							vself.vdescricaoprodutoedicao 	= produto.descricao;
							vself.vundprodutoedicao			= produto.und;
							vself.vfracionadoedicao			= produto.fracionado;
                            vself.vreferenciaedicao         = produto.referencia;
							vself.$nextTick(function () {
								$('#edqtditemedicao').focus();
							});
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.mtdlimparedicaoitem();
							$('#edidprodutoedicao').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.mtdlimparedicaoitem();
				}
            },			
            mtdconsultarproduto(){
				if (parseInt(this.opcrud) < 3){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
            mtdadicionaritem(){
				let vself = this;
				if (this.vcoddigedicao === ''){
					this.$toastr.w('Código do produto deve ser informado!', 'Atenção!');
					$('#edidprodutoedicao').focus();
					return;
				}
				if (parseFloat(this.vqtditemedicao) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemedicao').focus();
					return;
				}                
                if (parseInt(this.vfracionadoedicao) === 0){
                    if (!Number.isInteger(this.vqtditemedicao)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemedicao').focus();
                        return;
                    }
				}
                if (util.findValInArray(this.lstitenscotacao, 'idproduto', this.vidprodutoedicao)){                                
                    this.$toastr.w('Item já lançado na cotação!', 'Atenção!');
                    return;
                }
                vself.vitem++;
                let itemtmp = {
                    item			: vself.vitem,
                    idproduto		: vself.vidprodutoedicao,
                    descricao		: vself.vdescricaoprodutoedicao,
                    referencia      : vself.vreferenciaedicao,
                    coddig			: vself.vcoddigedicao,                    
                    qtditem			: vself.vqtditemedicao,
                    und			    : vself.vundprodutoedicao,
                };         
                vself.lstitenscotacao.push(itemtmp);       
                vself.mtdlimparedicaoitem();
                setTimeout(() => {
                    $('#edidprodutoedicao').focus();
                }, 200);
            },
            mtdexcluiritem(item){
                if (parseInt(this.opcrud) < 3){
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitenscotacao, 'item', item.item);
                    this.lstitenscotacao.splice(indiceitem, 1);                 
                }
            },
            mtdadicionarfornecedor(){
				if (this.vidfornecedoredicao === null){
					this.$toastr.w('Fornecedor deve ser informado!', 'Atenção!');
					$('#cbfornecedoredicao').select2('open');
					return;
				} 
				if (this.vemailfornecedoredicao === ''){
					this.$toastr.w('Email do fornecedor deve ser informado!', 'Atenção!');
					$('#edemailfornecedoredicao').focus();
					return;
				}   
				if (this.vcontatofornecedoredicao === ''){
					this.$toastr.w('Contato do fornecedor deve ser informado!', 'Atenção!');
					$('#edcontatofornecedoredicao').focus();
					return;
				}                                             
                if (util.findValInArray(this.lstfornecedorescotacao, 'idfornecedor', this.vidfornecedoredicao)){                                
                    this.$toastr.w('Fornecedor já lançado na cotação!', 'Atenção!');
                    return;
                }
                let itemtmp = {
                    idfornecedor	: this.vidfornecedoredicao,
                    fantasia		: $('#cbfornecedoredicao').select2('data')[0]['text'],
                    observacoes		: this.vobsfornecedoredicao,
                    email           : this.vemailfornecedoredicao,
                    contato			: this.vcontatofornecedoredicao,                    
                };         
                this.lstfornecedorescotacao.push(itemtmp);       
                this.mtdlimparedicaofornecedor();

            },
            mtdexcluirfornecedor(fornecedor){
                if (parseInt(this.opcrud) < 3){
                    let indice 		= util.getArrayIndexForKey(this.lstfornecedorescotacao, 'idfornecedor', fornecedor.idfornecedor);
                    this.lstfornecedorescotacao.splice(indice, 1);                 
                }
            },
            mtdimportaritenscoletor(){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listarcoletor'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        let itenstmp = response.data.itenscoletor;
                        if (vself.lstitenscotacao.length > 0){
                            vself.vitem  = vself.lstitenscotacao[vself.lstitenscotacao.length - 1].item;
                        }else{
                            vself.vitem  = 0;
                        }
                        for (let i = 0; i < itenstmp.length; i++) {
                            if (util.findValInArray(vself.lstitenscotacao, 'idproduto', itenstmp[i].idproduto)){
                            let ii = util.getArrayIndexForKey(vself.lstitenscotacao, 'idproduto', itenstmp[i].idproduto); 
                            vself.lstitenscotacao[ii].qtditem = parseFloat(vself.lstitenscotacao[ii].qtditem) + parseFloat(itenstmp[i].qtd);
                            }else{  
                                vself.vitem++;
                                let itemtmp = {
                                    item			: vself.vitem,
                                    idproduto		: itenstmp[i].idproduto,
                                    descricao		: itenstmp[i].descricao,
                                    referencia      : itenstmp[i].referencia,
                                    coddig			: '',                    
                                    qtditem			: itenstmp[i].qtd,
                                    und			    : itenstmp[i].und,
                                };
                                vself.lstitenscotacao.push(itemtmp);                        
                            }
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                });                 
            },
            async mtdgeralinkcotacaofornecedoratz(cotacao) {
                if (cotacao.situacao == 2) {
                    this.$toastr.w('Não é possível realizar ação: cotação finalizada.', 'Informação!');
                    return;
                }

                let idclientesac = parseInt(this.$store.state.filialpadrao.idcliente);
                let { id, idfilial, fornecedores } = cotacao;

                // Gera links de forma assíncrona e aguarda todas as respostas
                let dadosfornecedores = await Promise.all(fornecedores.map(async fornecedor => {
                    let parametroslink = {
                        idcotacao: id,
                        idclientesac,
                        idfilial,
                        idfornecedor: fornecedor.idfornecedor
                    };

                    let dadospedido = JSON.stringify(parametroslink);
                    let link = await this.criptografaurlcotacao(dadospedido);
                    return {
                         ...fornecedor,
                          link 
                        };
                }));

                this.lstlinkfornecedores = {
                     ...cotacao, 
                     fornecedores: dadosfornecedores };

                $('#mdlmenu').modal('hide');
                $('#mdllinkcotacao').modal('show');
            },
            async criptografaurlcotacao(dadospedido) {
                let loader = this.$loading.show();
                try {
                    let parametros = [
                        { parametro: 'op',              valor: 'geraurlcriptografada' },
                        { parametro: 'idclientesac',    valor: this.$store.state.filialpadrao.idcliente },
                        { parametro: 'dados',           valor: dadospedido }
                    ];

                    let response = await util.reqaxios(parametros, 'post', this.$store.state.usuario.adrsrv + '/controller/rtcadcotacoes.php');
                    return `http://localhost:8081/?token=${response.data.token}`;
                } catch (error) {
                    console.error('Erro ao gerar link:', error);
                    return null;
                } finally {
                    loader.hide();
                }
            },
            mtdcopialinkcotacao(link){
                let url = "";
                url = link;
                navigator.clipboard.writeText(url)
                    .then(() => {
                        this.$toastr.i('Link copiado para a área de transferência!', 'informação!');
                    })
                    .catch(err => {
                        this.$toastr.w('Erro ao copiar o link: ', 'Atenção!' + err);
                    });
            },
            mtdenviaemailcotacao(op, fornecedor, link){
                let vself = this;
                let text = "";
                if(op == 0){
                    text = "Deseja enviar o link da cotação para o fornecedor " + fornecedor.fantasia + "?";
                }
                if(op == 1){
                    text = "Deseja enviar o link da cotação para todos os fornecedores? ";
                }
                
                $.confirm({
                    title: 'Confirmação!',
                    content: text,
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                let loader = vself.$loading.show();
                                let parametros = [];
                                if(op == 0){
                                    parametros      = [
                                        {parametro: 'op',           valor : 'enviaremailcotacao'},
                                        {parametro: 'fornecedor',   valor : JSON.stringify(fornecedor)},
                                        {parametro: 'tpenvio',      valor : op},
                                        {parametro: 'linkcotacao',  valor : link},
                                        {parametro: 'idcotacao',    valor : vself.lstlinkfornecedores.id},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},

                                    ];
                                }else{
                                    parametros      = [
                                        {parametro: 'op',               valor : 'enviaremailcotacao'},
                                        {parametro: 'fornecedor',       valor : JSON.stringify(fornecedor)},
                                        {parametro: 'tpenvio',          valor : op},
                                        {parametro: 'idcotacao',        valor : vself.lstlinkfornecedores.id},
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                                    ];
                                }

                                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcotacoes.php');
                                retorno.then(function (response) {
                                    if (response.data.tentativasdeenvio.enviados[0]){
                                        vself.$toastr.s('Destinatário : '+ response.data.destinatario, 'E-mail enviado com sucesso!');
                                    }else{
                                        vself.$toastr.w('E - Não foi possivel envia o e-mail!', 'Destinatário: '+ response.data.destinatario);    
                                    }
                                    loader.hide();
                                }).catch(function (response) {
                                    vself.$toastr.i('Não foi possivel envia o e-mail!', 'Destinatário:');
                                    loader.hide();
                                });       
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdformatavalordecimal(valor, digitos){
                return util.formatavalordecimais(valor, digitos);
            },
            mtdexpandiritens(indice) {
                this.linhaExpandida = this.linhaExpandida === indice ? null : indice;
            },
            mldexibecotacao(lstcotacao, descfor, item){
                this.produtoscotacaofor = '';
                this.produtoscotacaofor = lstcotacao;
                this.titulocotacaofor = descfor;
                this.itemcotacao = item;
                $("#mdldetalhescotacao").modal('show');
            },
            mtdverificamenorpreco(listaDePrecos) {
                if (!listaDePrecos || listaDePrecos.length === 0) {
                    return null;
                }

                let listavalores = listaDePrecos
                    .map(preco => parseFloat(preco.vlunitario))
                    .filter(valor => valor > 0);

                if (listavalores.length === 0) {
                    return null;
                }

                return Math.min(...listavalores);
            },
            ordenamenorpreco(produtos) {
                let produtosFiltrados = produtos.filter(item => {
                    return parseFloat(item.vlunitario) > 0;
                });

                let lista = [...produtosFiltrados].sort((a, b) => {
                    return parseFloat(a.vlunitario) - parseFloat(b.vlunitario);
                });
                return lista.slice(0, 3);
            },
            mtdatualizaprecofornecedor(precos, idfornecedor){
                 let fornecedorEncontrado = precos.find(
                    (fornecedor) => fornecedor.idfornecedor == idfornecedor
                );
                 return fornecedorEncontrado ? parseFloat(fornecedorEncontrado.vlunitario) : 0;
            },
            mtdrealizarpedidocompra(lstprodutoscotacoa, idfornecedor, op){
                let parametrospedidocompra = {};
                if(op == 1){
                    parametrospedidocompra = {
                        ...lstprodutoscotacoa,
                        idfilial : this.vidfilial,
                        fantasiafil : this.fantasiafil.text
                    }
                }
                if(op == 2){
                    if(!idfornecedor){
                        this.$toastr.i('Selecione um fornecedor.', 'Informação');
                        return;
                    }

                    let filtroparametros = this.lstcotacaofornecedores.find(fornecedor => fornecedor.idfornecedor == idfornecedor);
                    let produtosselecionados = lstprodutoscotacoa.map(selectproduto => selectproduto.idproduto);
                    let produtos = filtroparametros.produtoscotacao.filter(produto => {
                        return produtosselecionados.includes(produto.idproduto);
                    });


                    parametrospedidocompra = {
                        idfornecedor        : filtroparametros.idfornecedor,
                        idcotacao           : filtroparametros.idcotacao,
                        nomerazaosocial     : filtroparametros.nomerazaosocial,
                        observacao          : filtroparametros.observacao,
                        idfilial            : this.vidfilial,
                        fantasiafil         : this.fantasiafil.text,
                        produtoscotacao     : produtos,
                    }
                }

                localStorage.setItem('dadospedidocompra', JSON.stringify(parametrospedidocompra));
                let rotapedidocompra = this.$router.resolve({ 
                    name: 'cadpedidoscompra' 
                });
                window.open(rotapedidocompra.href, '_blank');
                // this.$router.push({ name: 'cadpedidoscompra', params: { lstprodutospedido: lstprodutoscotacoa } })
                
                this.lstitenspedido = []
                // $.confirm({
                //     title: 'Confirmação!',
                //     content: 'Deseja realizar o pedido de compra com o fornecedor e itens selecionados?',
                //     icon: 'fa fa-question-circle',
                //     backgroundDismiss: false,
                //     escapeKey: 'nao',
                //     type: 'dark',
                //     typeAnimated: true,
                //     buttons: {
                //         sim: {
                //             text: '<u>S</u>im',
                //             keys: ['s', 'S'],
                //             btnClass: 'btn-blue',
                //             action: () => {

                                
                //             },
                //         },
                //         nao: {
                //             text: '<u>N</u>ão',
                //             keys: ['n', 'N'],
                //             action: function () {
                //                 $('#btgravar').focus();
                //                 this.lstitenspedido = []
                //             }
                //         }
                //     }
                // });
            },
            mtdgerarpedidocompraitens(){
                this.lstitensselecionadospedido = [];
                this.fornecedorpedidoitem = '';

                if(this.lstitenspedido.length > 0 ){
                    this.lstitensselecionadospedido = this.lstitenspedido
                    $("#mdlpedidoitem").modal('show');
                }else{
                    this.$toastr.i('É necessário selecionar ao menos um item.', 'Atenção!');
                }
            },
            mtdfechamodalpedidoitens(){
                $("#mdlpedidoitem").modal('hide');
                this.lstitenspedido = []
            },
            mtdmostrarmenu(pedido){			
				this.rowcotacao = pedido;
				$('#mdlmenu').modal('show');
			},
            mdtexibeprodutoscardcotacao(item){

                this.exibeprodutoscard = item;
                // console.log(this.exibeprodutoscard);
                $('#mdlexibeprodutoscard').modal('show');
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                let loader          = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    $('[data-toggle="tooltip"]').tooltip();
                
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }
                    if (util.opcaousuario('010Z.003Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtddefiniciais();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                    
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vidfilial === null || this.vdescricao === '' || this.vdtemissao === null ||
                this.lstitenscotacao.length === 0 || this.lstfornecedorescotacao.length === 0 ; 
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
            selecionaperiodo() {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregacotacoes(val);
            },			
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.mtdlocalizarproduto(this.vcoddigedicao);					
                }
			},
            lstcotacaofornecedores: {
                handler(newValue) {
                    newValue.sort((a, b) => a.totalpedido - b.totalpedido);
                },
            },
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    .def-col-situacao{
        width: 90px !important;
    }
    .bdg-digitacao{
        background: #6BA2D0!important;        
    }
    .bdg-aguardando{
        background: #EEA435!important;
        color: white;
    }
    .bdg-entregue{
        background: #5A956A!important;
    }
    .def-col-descricao{
        width: 800px !important;
    }
    .def-col-idcodigo{
        width: 80px;
    }
    .def-col-und{
        width: 80px;
    }
    .def-col-qtditem{
        width: 80px;
    }
    .def-col-idfornecedor{
        width: 60px;
    }
    .menorpreco {
    color: green;
    font-weight: bold;
    }
    .limitadotext {
        width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;;
    }
    .cardcotacao{
        box-shadow: 4px 5px 10px rgba(0, 0, 0, 0.3);
    }
    .headermelhorpreco::before {
        content: 'Melhor Oferta!';
        position: absolute;
        top: 0;
        right: 0;
        background-color: #28a745;
        color: #fff;
        padding: 5px 10px;
        font-size: 0.8rem;
        font-weight: bold;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }
    .headercardcotacao {
        background-color: #e9ecef;
        border-bottom: 1px solid #ced4da;
        padding: 1rem 1.5rem;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .headercardcotacao.headermelhorpreco {
        background-color: #28a745;
        color: #fff;
    }
    .totalpedido {
        font-size: 2rem;
        font-weight: bold;
        color: #007bff;
    }
    .headermelhorpreco .totalpedido {
        color: #fff;
    }
    .totalpedido th, .totalpedido td {
        font-size: 0.9rem;
    }
    .totalpedido {
        margin-bottom: 0;
    }
    .btnpedidocotacao {
        border-radius: 50px;
        font-weight: bold;
        margin-bottom: 5px;
    }
    .btnexibecard{
        font-weight: bold;
        margin-bottom: 5px;
        width: 150px;
        font-size: 0.8rem;
        border: 15px solid #fff;
    }
</style>